export default [
  {
    path: "/app/teachers",
    component: () => import("../views"),
    meta: {
      title: "Educasis - Professor",
      requiresAuth: true,
    },
    children: [
      {
        path: "sagres/v2",
        name: "teacher.sagres.v2",
        component: () => import("../sagres/index2.vue"),
        meta: {
          permission: "view_sagres",
        },
      },
      {
        path: "sagres",
        name: "teacher.sagres",
        component: () => import("../sagres/index.vue"),
        meta: {
          permission: "view_sagres",
        },
      },
      /* AEE */
      {
        path: "aee/planning",
        name: "teacher.aee.planning",
        component: () => import("../aee/planning/views/List"),
        meta: {
          permission: "view_lesson_planning_aee",
        },
      },
      {
        path: "aee/planning/create",
        name: "teacher.aee.planning.create",
        component: () => import("../aee/planning/views/Create"),
        meta: {
          permission: "view_lesson_planning_aee",
        },
      },
      {
        path: "aee/planning/edit/:id",
        name: "teacher.aee.planning.edit",
        component: () => import("../aee/planning/views/Edit"),
        meta: {
          permission: "view_lesson_planning_aee",
        },
      },
      {
        path: "aee/planning/copy/:id",
        name: "teacher.aee.planning.copy",
        component: () => import("../aee/planning/views/Copy"),
        meta: {
          permission: "view_lesson_planning_aee",
        },
      },
      {
        path: "aee/planning/show/:id",
        name: "teacher.aee.planning.show",
        component: () => import("../aee/planning/views/Show"),
        meta: {
          permission: "view_lesson_planning_aee",
        },
      },
      //----------------------------RECORD-AEE----------------------------
      {
        path: "aee/record-aee",
        name: "teacher.aee.record-aee",
        component: () => import("../aee/record-aee/views/List"),
        meta: {
          permission: "view_record_aee",
        },
      },
      {
        path: "aee/record-aee/create",
        name: "teacher.aee.record-aee.create",
        component: () => import("../aee/record-aee/views/Create"),
        meta: {
          permission: "view_record_aee",
        },
      },
      {
        path: "aee/record-aee/edit/:id",
        name: "teacher.aee.record-aee.edit",
        component: () => import("../aee/record-aee/views/Edit"),
        meta: {
          permission: "view_record_aee",
        },
      },
      {
        path: "aee/record-aee/show/:id",
        name: "teacher.aee.record-aee.show",
        component: () => import("../aee/record-aee/views/Show"),
        meta: {
          permission: "view_record_aee",
        },
      },
      //----------------------------SERVICE-AEE----------------------------
      {
        path: "aee/service-aee",
        name: "teacher.aee.service-aee",
        component: () => import("../aee/service-aee/views/List"),
        meta: {
          permission: "view_service_aee",
        },
      },
      {
        path: "aee/service-aee/create",
        name: "teacher.aee.service-aee.create",
        component: () => import("../aee/service-aee/views/Create"),
        meta: {
          permission: "view_service_aee",
        },
      },
      {
        path: "aee/service-aee/edit/:id/:registration",
        name: "teacher.aee.service-aee.edit",
        component: () => import("../aee/service-aee/views/Edit"),
        meta: {
          permission: "view_service_aee",
        },
      },
      {
        path: "aee/service-aee/show/:id",
        name: "teacher.aee.service-aee.show",
        component: () => import("../aee/service-aee/views/Show"),
        meta: {
          permission: "view_service_aee",
        },
      },
      // ----------------------------STUDY-CASE----------------------------
      {
        path: "aee/study-case",
        name: "teacher.aee.study-case",
        component: () => import("../aee/study-case/views/List"),
        meta: {
          permission: "view_study_case_aee",
        },
      },
      {
        path: "aee/study-case/create",
        name: "teacher.aee.study-case.create",
        component: () => import("../aee/study-case/views/Create"),
        meta: {
          permission: "add_study_case_aee",
        },
      },
      {
        path: "aee/study-case/edit/:id",
        name: "teacher.aee.study-case.edit",
        component: () => import("../aee/study-case/views/Edit"),
        meta: {
          permission: "add_study_case_aee",
        },
      },
      {
        path: "aee/study-case/show/:id",
        name: "teacher.aee.study-case.show",
        component: () => import("../aee/study-case/views/Show"),
        meta: {
          permission: "view_study_case_aee",
        },
      },
      // ----------------------------PAEE----------------------------
      {
        path: "aee/paee",
        name: "teacher.aee.paee",
        component: () => import("../aee/paee/views/List"),
        meta: {
          permission: "view_paee",
        },
      },
      {
        path: "aee/paee/create",
        name: "teacher.aee.paee.create",
        component: () => import("../aee/paee/views/Create"),
        meta: {
          permission: "add_paee",
        },
      },
      {
        path: "aee/paee/edit/:id",
        name: "teacher.aee.paee.edit",
        component: () => import("../aee/paee/views/Edit"),
        meta: {
          permission: "add_paee",
        },
      },
      {
        path: "aee/paee/show/:id",
        name: "teacher.aee.paee.show",
        component: () => import("../aee/paee/views/Show"),
        meta: {
          permission: "view_paee",
        },
      },
      /* reports */
      {
        path: "aee/reports/service-aee",
        name: "teacher.aee.reports.service-aee",
        component: () => import("../aee/reports/service-aee/views/List.vue"),
        meta: {
          permission: "view_report_service_aee",
        },
      },
      //------------------------------TYPE RESOURCE----------------------------
      {
        path: "aee/types/resource",
        name: "teacher.aee.types.resource",
        component: () => import("../aee/types/resource/views/List.vue"),
        meta: {
          permission: "view_type_resource",
        },
      },
      {
        path: "aee/types/resource/create",
        name: "teacher.aee.types.resource.create",
        component: () => import("../aee/types/resource/views/Create.vue"),
        meta: {
          permission: "add_type_resource",
        },
      },
      {
        path: "aee/types/resource/edit/:id",
        name: "teacher.aee.types.resource.edit",
        component: () => import("../aee/types/resource/views/Edit.vue"),
        meta: {
          permission: "add_type_resource",
        },
      },
      {
        path: "aee/types/resource/show/:id",
        name: "teacher.aee.types.resource.show",
        component: () => import("../aee/types/resource/views/Show.vue"),
        meta: {
          permission: "view_type_resource",
        },
      },
      //---------------------------------TA/CAA-------------------------------
      {
        path: "aee/types/ta-caa",
        name: "teacher.aee.types.ta-caa",
        component: () => import("../aee/types/ta-caa/views/List.vue"),
        meta: {
          permission: "view_type_ta_caa",
        },
      },
      {
        path: "aee/types/ta-caa/create",
        name: "teacher.aee.types.ta-caa.create",
        component: () => import("../aee/types/ta-caa/views/Create.vue"),
        meta: {
          permission: "add_type_ta_caa",
        },
      },
      {
        path: "aee/types/ta-caa/edit/:id",
        name: "teacher.aee.types.ta-caa.edit",
        component: () => import("../aee/types/ta-caa/views/Edit.vue"),
        meta: {
          permission: "add_type_ta_caa",
        },
      },
      {
        path: "aee/types/ta-caa/show/:id",
        name: "teacher.aee.types.ta-caa.show",
        component: () => import("../aee/types/ta-caa/views/Show.vue"),
        meta: {
          permission: "view_type_ta_caa",
        },
      },
      //---------------------------------REFERRAL------------------------------
      {
        path: "aee/types/referral",
        name: "teacher.aee.types.referral",
        component: () => import("../aee/types/referral/views/List.vue"),
        meta: {
          permission: "view_type_domain_referral",
        },
      },
      {
        path: "aee/types/referral/create",
        name: "teacher.aee.types.referral.create",
        component: () => import("../aee/types/referral/views/Create.vue"),
        meta: {
          permission: "add_type_domain_referral",
        },
      },
      {
        path: "aee/types/referral/edit/:id",
        name: "teacher.aee.types.referral.edit",
        component: () => import("../aee/types/referral/views/Edit.vue"),
        meta: {
          permission: "add_type_domain_referral",
        },
      },
      {
        path: "aee/types/referral/show/:id",
        name: "teacher.aee.types.referral.show",
        component: () => import("../aee/types/referral/views/Show.vue"),
        meta: {
          permission: "view_type_domain_referral",
        },
      },
      /* /AEE */

      /* Activities */
      //----------------------------ACTIVITY REGISTER----------------------------
      {
        path: "activity-register",
        name: "teacher.activity-register",
        component: () => import("../activity/activity-register/views/List"),
        meta: {
          permission: "view_activity_register",
        },
      },
      {
        path: "activity-register/create",
        name: "teacher.activity-register.create",
        component: () => import("../activity/activity-register/views/Create"),
        meta: {
          permission: "view_activity_register",
        },
      },
      {
        path: "activity-register/edit/:id",
        name: "teacher.activity-register.edit",
        component: () => import("../activity/activity-register/views/Edit"),
        meta: {
          permission: "view_activity_register",
        },
      },
      //----------------------------ACTIVITY NOTE----------------------------
      {
        path: "activity-note",
        name: "teacher.activity-note.create",
        component: () => import("../activity/activity-note/views/List"),
        meta: {
          permission: "view_activity_note",
        },
      },
      /* Activities */

      /* Class Diary */
      //----------------------------FREQUENCY----------------------------

      {
        path: "frequencies",
        name: "teacher.frequencies",
        component: () => import("../frequency/views/List"),
        meta: {
          permission: "view_frequency",
        },
      },
      {
        path: "frequencies/create/:cod_turma?/:week_day?",
        name: "teacher.frequencies.create",
        component: () => import("../frequency2/views/Create.vue"),
        meta: {
          name: "Frequencia - Criar",
          permission: "add_frequency",
        },
      },
      {
        path: "frequencies/edit/:id",
        name: "teacher.frequencies.edit",
        component: () => import("../frequency/views/Edit.vue"),
        meta: {
          permission: "view_frequency",
        },
      },
      {
        path: "frequencies/show/:id",
        name: "teacher.frequencies.show",
        component: () => import("../frequency/views/Show.vue"),
        meta: {
          permission: "view_frequency",
        },
      },
      {
        path: "frequencies/class-map",
        name: "teacher.frequencies.class-map",
        component: () => import("../class-map/views/ClassMap.vue"),
        meta: {
          permission: "view_frequency",
        },
      },
      //----------------------------NOTES----------------------------
      // {
      //   path: "notes",
      //   name: "teacher.notes",
      //   component: () => import("../notes/views/List"),
      // },
      {
        path: "notes",
        name: "teacher.notes",
        component: () => import("../notes/views/List"),
        meta: {
          permission: "view_note",
        },
      },
      //----------------------------CLASS REPLACEMENT----------------------------
      {
        path: "class-replacement",
        name: "teacher.class-replacement",
        component: () => import("../class-replacement/views/List.vue"),
        meta: {
          permission: "view_class_replacement",
        },
      },
      /* Class Diary */

      /* Occurrence Disciplinary */
      {
        path: "registration-occurrence-disciplinary",
        name: "teacher.registration.occurrence.disciplinary",
        component: () => import("../occurrence-disciplinary/views/List"),
        meta: {
          permission: "view_occurrence",
        },
      },
      {
        path: "registration-occurrence-disciplinary/create",
        name: "teacher.registration.occurrence.disciplinary.create",
        component: () => import("../occurrence-disciplinary/views/Create"),
        meta: {
          permission: "view_occurrence",
        },
      },
      {
        path: "registration-occurrence-disciplinary/edit/:id",
        name: "teacher.registration.occurrence.disciplinary.edit",
        component: () => import("../occurrence-disciplinary/views/Edit"),
        meta: {
          permission: "view_occurrence",
        },
      },
      /* /Occurrence Disciplinary */

      /* Planning */
      {
        path: "planning",
        name: "teacher.planning",
        component: () => import("../planning/views/List"),
        meta: {
          permission: "view_lesson_planning",
        },
      },
      {
        path: "planning/create",
        name: "teacher.planning.create",
        component: () => import("../planning/views/Create"),
        meta: {
          permission: "view_lesson_planning",
        },
      },
      {
        path: "planning/edit/:id",
        name: "teacher.planning.edit",
        component: () => import("../planning/views/Edit"),
        meta: {
          permission: "view_lesson_planning",
        },
      },
      {
        path: "planning/copy/:id",
        name: "teacher.planning.copy",
        component: () => import("../planning/views/Copy"),
        meta: {
          permission: "view_lesson_planning",
        },
      },
      {
        path: "planning/show/:id",
        name: "teacher.planning.show",
        component: () => import("../planning/views/Show"),
        meta: {
          permission: "view_lesson_planning",
        },
      },
      /* /Planning */
    ],
  },
];
